import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import Deprecated from '../../core/Deprecated';
import SearchDropDown from '../../core/SearchDropDown';
import { getArrayValues, getComponents } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import ComponentLinkList from './ComponentLinkList';

class ProjectOntologySearch extends Component {

  onFoundResource = (id, result) => {
    if ("isDefinedBy" in result || "visibility" in result) {
      // Find the first loaded ontology
      // Visibility first because isDefinedBy maybe be different to ontology
      const ontology = getComponents(result, true, true)[0];
      const foundOntology = GS.isLoaded(ontology, this.props.graph);
      const dataTypes = getArrayValues(result, "type");
      if (foundOntology) {
        let view = "class";
        if (dataTypes.includes("ObjectProperty")) {
          view = "objectProperty";
        }
        else if (dataTypes.includes("DatatypeProperty")) {
          view = "datatypeProperty";
        }
        else if (dataTypes.includes("AnnotationProperty")) {
          view = "annotationProperty";
        }
        else if (dataTypes.includes("NamedIndividual")) {
          view = "namedIndividual";
        }
        else if (dataTypes.includes("RdfsDatatype")) {
          view = "datatype";
        }
        const link = APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project=' +
          this.props.project + "&ontology=" + ontology + "&view=" + view + "&" + view + "=" + id;

        this.props.history.push(link);
      }
    }
  };

  render() {

    const { defaultLang, graph } = this.props;

    return (
      <div style={{ height: 40, maxWidth: 400, marginBottom: 12, overflow: 'visible' }}>
        <SearchDropDown
          dataTest="find-ontology"
          search={(value, lang) => {
            return {
              search: [{
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: [
                  "http://www.w3.org/2002/07/owl#Class",
                  "http://www.w3.org/2002/07/owl#AnnotationProperty",
                  "http://www.w3.org/2002/07/owl#DatatypeProperty",
                  "http://www.w3.org/2002/07/owl#ObjectProperty",
                  "http://www.w3.org/2002/07/owl#NamedIndividual",
                  "http://www.w3.org/2000/01/rdf-schema#Datatype"
                ]
              },
              {
                predicate: [
                  "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                  "https://grafsync.graphifi.com/schema/gs/visibility"
                ]
              },
              {
                predicate: ["http://www.w3.org/2000/01/rdf-schema#label"],
                value: value,
                isExactMatch: false
              }],
              exclude: [
                "https://graphifi.com/schema/xowl/topAnnotationProperty",
                "http://www.w3.org/2002/07/owl#topObjectProperty",
                "http://www.w3.org/2002/07/owl#topDataProperty",
                "http://www.w3.org/2002/07/owl#Thing"
              ],
              graph: [graph],
              allowMissingResults: true,
              language: lang,
              predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                "https://grafsync.graphifi.com/schema/gs/visibility"
              ]
            };
          }}
          sortProp="label"
          suppressMessages={true}
          listSecondIcon={(result) => {
            if (result.deprecated) return <Deprecated />;
            return null;
          }}
          listDisplay={(result, lang) => {
            const dataTypes = Array.isArray(result.type) ? result.type : [result.type];
            let viewType = "Class";
            if (dataTypes.includes("ObjectProperty")) {
              viewType = "Object Property";
            }
            else if (dataTypes.includes("DatatypeProperty")) {
              viewType = "Datatype Property";
            }
            else if (dataTypes.includes("AnnotationProperty")) {
              viewType = "Annotation Property";
            }
            else if (dataTypes.includes("NamedIndividual")) {
              viewType = "Named Individual";
            }
            else if (dataTypes.includes("RdfsDatatype")) {
              viewType = "Datatype";
            }
            return <div>
              <div data-test="result-label">
                <Typography variant="body2">
                  <span style={{ wordBreak: 'break-word' }}>
                    {result.label[lang] ?
                      result.label[lang]
                      :
                      result.id
                    }
                  </span>
                </Typography>
              </div>
              <Typography data-test="result-type" variant="caption">{viewType}</Typography>
              <ComponentLinkList
                includeIsDefinedBy={true}
                data={result}
                graph={graph}
                defaultLang={defaultLang}
              />
            </div>;
          }}
          listSelectionDisplay={(result, lang) => {
            if (result.label && result.label[lang]) {
              return result.label[lang];
            }
            else return result.id;
          }}
          title="Find a project resource"
          lang={defaultLang}
          chosen={this.onFoundResource} />
      </div>
    );
  }

}

ProjectOntologySearch.propTypes = {
  project: PropTypes.string.isRequired,
  history: PropTypes.object,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(ProjectOntologySearch);